module.exports = __webpack_public_path__ + "img/product-ketang-jbg-04.e26f743e.png";